import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { showProvince } from '../../api/destinationApi';
import { Seo, Loading, EmptyContent } from '../shared';
import MediaFrame from '../shared/MediaFrame';
import '../../styles/destinations.scss';
import '../../styles/guides.scss';
import '../../styles/media.scss';

function ProvinceDetailPage() {
	const { slug } = useParams();
	const [province, setProvince] = useState(null);
	const [loading, setLoading] = useState(true);
	const [notFound, setNotFound] = useState(false);

	useEffect(() => {
		setLoading(true);
		setNotFound(false);
		showProvince(slug)
			.then((res) => setProvince(res.data))
			.catch(() => setNotFound(true))
			.finally(() => setLoading(false));
	}, [slug]);

	if (loading) return <Loading />;

	if (notFound || !province) {
		return (
			<div className="container py-5">
				<EmptyContent>
					<i className="fas fa-landmark text-muted" style={{ fontSize: '2rem' }} aria-hidden="true" />
					<h3 className="mt-3">Province not found</h3>
					<Link to="/provinces" className="btn btn-primary mt-2">Browse all provinces</Link>
				</EmptyContent>
			</div>
		);
	}

	const p = province;
	const districts = p.districts || [];

	return (
		<div className="destination-detail">
			<Seo
				title={`${p.name} Province`}
				path={`/provinces/${p.slug}`}
				description={p.description || `Explore ${p.name} Province, Nepal — districts, destinations, and practical travel information.`}
			/>

			<MediaFrame category="province" seed={p.slug} alt={`${p.name} Province`} variant="hero" className="destination-hero">
				<div className="destination-hero__overlay" />
				<div className="container destination-hero__content">
					<nav className="destination-breadcrumb" aria-label="Breadcrumb">
						<Link to="/provinces">Provinces</Link>
					</nav>
					<h1 className="text-white">{p.name} Province</h1>
					{p.description && <p className="text-white destination-hero__summary">{p.description}</p>}
				</div>
			</MediaFrame>

			<div className="container destination-detail__body">
				<div className="quick-facts">
					<div className="quick-fact">
						<i className="fas fa-map-marker-alt" aria-hidden="true" />
						<div>
							<span className="quick-fact__label">Districts</span>
							<span className="quick-fact__value">{districts.length}</span>
						</div>
					</div>
				</div>

				{districts.length > 0 && (
					<section className="destination-section">
						<h2>Districts in {p.name}</h2>
						<div className="guide-grid">
							{districts.map((d) => (
								<Link key={d.slug} to={`/districts/${d.slug}`} className="guide-card">
									<h3 className="guide-card__title">{d.name}</h3>
									{d.description && <p className="guide-card__summary">{d.description}</p>}
								</Link>
							))}
						</div>
					</section>
				)}
			</div>
		</div>
	);
}

export default ProvinceDetailPage;
